import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { tap, catchError } from "rxjs/operators";
import { BehaviorSubject, Observable } from "rxjs";
import { NGXLogger } from "ngx-logger";

import { environment } from "src/environments/environment";
import { BaseService } from "../services/base.service";
import {
  CallNotificationPagedList,
  CallNotificationSearchBody,
} from "src/swagger-gen/web-secured/models";

@Injectable({
  providedIn: "root",
})
export class CallLogRepo extends BaseService {
  baseUrl = environment.apiUrl;
  eventUrl = this.baseUrl + "/notification/call/";

  readonly DEFAULT_LIMIT = "50";

  constructor(private logger: NGXLogger, private httpClient: HttpClient) {
    super();
  }

  /**
   * Get all active alarms
   * @param limit number
   * @param offset number
   * @returns Observable result
   */
  getCallLogs(
    params: any[],
    body: CallNotificationSearchBody,
    limit?: number,
    offset?: number
  ): Observable<CallNotificationPagedList> {
    const searchUrl = this.eventUrl + "search";
    const paging = this.pagination(offset, limit, this.DEFAULT_LIMIT);

    let requestString: string;
    requestString = paging;
    let queryParams = "";
    params.forEach((p: any) => {
      queryParams += "&" + p.key + "=" + p.value;
    });
    requestString += queryParams;
    const requestParams = new HttpParams({ fromString: requestString });
    const httpOptions = {
      headers: this.httpHeaders(),
      params: requestParams,
    };

    return this.httpClient
      .post<CallNotificationPagedList>(searchUrl, body, httpOptions)
      .pipe(
        tap((events: CallNotificationPagedList) => {
          this.logger.log(`Got ${events.paging.totalItems} logs in service.`);
        }), // DEBUG
        catchError(this.handleServerError)
      );
  }

  exportCallLog(params: any[]): Observable<any> {
    let queryParams = "";
    params.forEach((p: any, i: number) => {
      queryParams += `${i > 0 ? "&" : ""}` + p.key + "=" + p.value;
    });

    const url = `${this.eventUrl}export`;
    const requestParams = new HttpParams({ fromString: queryParams });

    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json");

    const httpOptions: any = {
      headers: headers,
      params: requestParams,
      responseType: "blob" as "json",
      observe: "response",
    };

    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap((data) => {
        this.logger.trace(`Download all transactions:`, data);
      }), // DEBUG
      catchError(this.handleServerError)
    );
  }
}
